import {
  type AiBuilderMessage,
  useAiBuilderChatMessagesSelector,
} from '../stores';

/** 퀴즈 폼을 실제로 변형하는 progress 스텝 id. 검색 등 조회성 progress는 잠금 대상이 아니다. */
const QUESTION_MUTATION_PROGRESS_STEP_IDS = new Set([
  'apply-achievement',
  'compose',
  'review',
  'sync',
  'generating',
  'applying',
]);
const APPLYING_PROGRESS_STEP_ID = 'applying';

export type AiBuilderGenerationOverlayMode = 'generation' | 'applying';

/**
 * "지금 AI가 퀴즈 목록을 변형 중인가"를 메시지 스트림에서 판정한다.
 * 잠금 여부와 오버레이 문구 모드(generation/applying)를 함께 반환한다.
 */
export const useAiBuilderQuestionMutationLock = (): {
  isQuestionMutationRunning: boolean;
  overlayMode: AiBuilderGenerationOverlayMode;
} => {
  const { messages } = useAiBuilderChatMessagesSelector();
  const runningMessage = getRunningQuestionMutationProgressMessage(messages);

  return {
    isQuestionMutationRunning: runningMessage !== undefined,
    overlayMode: getGenerationOverlayMode(runningMessage),
  };
};

const isRunningQuestionMutationProgressMessage = (
  message: AiBuilderMessage,
) => {
  return (
    message.kind === 'progress' &&
    message.status === 'running' &&
    message.steps.some(step => QUESTION_MUTATION_PROGRESS_STEP_IDS.has(step.id))
  );
};

const getRunningQuestionMutationProgressMessage = (
  messages: AiBuilderMessage[],
) => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];

    if (isRunningQuestionMutationProgressMessage(message)) return message;
  }

  return undefined;
};

const getGenerationOverlayMode = (
  message: AiBuilderMessage | undefined,
): AiBuilderGenerationOverlayMode => {
  if (
    message?.kind === 'progress' &&
    message.steps.some(step => step.id === APPLYING_PROGRESS_STEP_ID)
  ) {
    return 'applying';
  }

  return 'generation';
};
